export default __webpack_public_path__ + "static/media/Ruby-on-Rails.4a6a857d.svg";